/* eslint-disable */
import { AlertAdapter, RegularButton, Loader, FullScreenLoading } from 'pg-ui-library';
import { useParams, useNavigate } from 'react-router-dom';
import React from 'react';
import ReactModal from 'react-modal';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'src/modules/login/components/mfa-modal/styles';
import closeSvg from 'src/assets/close.svg';
import * as yup from 'yup';
import { useFormik } from 'formik';
import { useQuery } from '@tanstack/react-query';
import ExpenseService from 'src/services/expense.service';

import { useRejectExpense } from '../mutations/expense.mutation';

import {
  ReopenTicketForm,
  ReopenTicketBody,
  ReopenTicketHeader,
  ReplyTextarea,
  ReopenFooter,
  ReopenQues,
  ReopenLabel,
} from './styles';

export const ExpenseRejectionModal: React.FC<{
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  expenseDetail?: any;
  // eslint-disable-next-line react/prop-types
}> = ({ isOpen, setIsOpen, expenseDetail }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const expenseIdShown = expenseDetail?.expenseShowId;
  const { expenseId } = useParams<{ expenseId: string }>();
  console.log();
  const companyId = '';

  const { isFetching, data, refetch } = useQuery(['expense-details'], async () => {
    const result = await ExpenseService.getExpenseDetails({ expenseId: expenseId });
    return result.data;
  });

  const rejectExpense = useRejectExpense();

  const handleModal = () => {
    setIsOpen(!isOpen);
  };

  const formik = useFormik({
    initialValues: {
      comment: '',
    },
    onSubmit: async (values: any) => {
      if (!expenseId) {
        return;
      }
      await rejectExpense.mutateAsync({ expenseId: expenseId, expense: values });

      AlertAdapter('expense is Rejected!', 'success');
      refetch();
      setIsOpen(!isOpen);
      navigate('/expenses');
    },
  });

  return (
    // eslint-disable-next-line react/react-in-jsx-scope
    <ReactModal
      isOpen={isOpen}
      ariaHideApp={false}
      onRequestClose={handleModal}
      style={{
        overlay: {
          margin: 'auto',
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
        content: {
          borderRadius: '30px',
          margin: 'auto',
          width: '700px',
          height: '420px',
          display: 'flex',
          flexDirection: 'column',
          padding: '0 40px 0 40px',
          background: '#F3F4F8',
          overflowY: 'hidden',
        },
      }}
    >
      <ReopenTicketForm onSubmit={formik.handleSubmit}>
        <ReopenTicketHeader>
          <h3 style={{ margin: 0, width: '80%' }}>
            {t('global.form.rejectExpense')} #{expenseIdShown}
          </h3>

          <CloseIcon
            src={closeSvg}
            onClick={handleModal}
            style={{
              position: 'absolute',
              right: '40px',
              top: '20px',
              cursor: 'pointer',
            }}
          />
        </ReopenTicketHeader>

        <ReopenTicketBody>
          <ReopenQues>
            <p>Are you sure you want to Reject this Expense?</p>
          </ReopenQues>
          <ReopenLabel>Comment</ReopenLabel>
          <ReplyTextarea
            placeholder="Enter here..."
            value={formik.values.comment}
            onChange={event => formik.setFieldValue('comment', event.target.value)}
          />
          <ReopenFooter>
            <RegularButton
              disabled={formik.isSubmitting || !formik.isValid}
              type="button"
              style={{ color: '#4948AC', backgroundColor: '#fff' }}
              onClick={() => handleModal()}
            >
              {t('global.form.cancel')}
            </RegularButton>
            {rejectExpense.isLoading ? <FullScreenLoading /> : <RegularButton type="submit">Confirm</RegularButton>}
          </ReopenFooter>
        </ReopenTicketBody>
      </ReopenTicketForm>
    </ReactModal>
  );
};
